import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from "../../../../common/Loader";
import { MatchStatus } from "../../../../Utils";
import styles from "./StatisticsModal.module.css";
import { resultSign } from "./utils";

const StatisticsModal = ({ homeTeam, awayTeam, fansUnitedSDK }) => {
	const { t } = useTranslation();

	const MATCHES_COUNT = 5;

	const [selectedTeam, setSelectedTeam] = useState(homeTeam.id);
	const [homeTeamMatches, setHomeTeamMatches] = useState([]);
	const [awayTeamMatches, setAwayTeamMatches] = useState([]);

	const [isLoading, setIsLoading] = useState(false);

	const getMatchesStatistics = async () => {
		setIsLoading(true);

		const homeTeamMatchesResponse = await fansUnitedSDK.football.getMatches({
			teamIds: [homeTeam.id],
			status: MatchStatus.FINISHED,
			limit: MATCHES_COUNT,
			sortField: "date",
			sortOrder: "desc",
		});
		setHomeTeamMatches(homeTeamMatchesResponse.data);

		const awayTeamMatchesResponse = await fansUnitedSDK.football.getMatches({
			teamIds: [awayTeam.id],
			status: MatchStatus.FINISHED,
			limit: MATCHES_COUNT,
			sortField: "date",
			sortOrder: "desc",
		});
		setAwayTeamMatches(awayTeamMatchesResponse.data);

		setIsLoading(false);
	};

	useEffect(() => {
		getMatchesStatistics();
	}, []);

	const TeamTab = ({ team, isActive }) => (
		<button className={`${styles.teamTab} ${isActive ? styles.activeTab : ""}`} onClick={() => setSelectedTeam(team.id)}>
			{t(team.name)}
		</button>
	);

	const MatchRow = ({ match }) => {
		const sign = resultSign(match, selectedTeam);
		const matchDate = new Date(match.finishedAt);
		const formattedDate = `${matchDate.getDate()} ${matchDate.toLocaleDateString("en", { month: "short" })} FT`;

		// Determine which team to show first based on home/away status
		const topTeam = match.homeTeam;
		const bottomTeam = match.awayTeam;
		const topScore = match.scores.ftScore.homeGoals;
		const bottomScore = match.scores.ftScore.awayGoals;

		return (
			<div className={styles.matchContainer}>
				<div className={styles.matchDate}>{formattedDate}</div>
				<div className={styles.matchRow}>
					<div className={styles.teamRow}>
						<img className={styles.teamIcon} src={topTeam.assets?.logo} alt={`${topTeam.name}-logo`} />
						<span className={styles.teamName}>{t(topTeam.name)}</span>
						<span className={styles.score}>{topScore}</span>
					</div>
					<div className={styles.teamRow}>
						<img className={styles.teamIcon} src={bottomTeam.assets?.logo} alt={`${bottomTeam.name}-logo`} />
						<span className={styles.teamName}>{t(bottomTeam.name)}</span>
						<span className={styles.score}>{bottomScore}</span>
					</div>
					<div className={styles.resultIcon} style={{ backgroundColor: sign.color }}>
						{sign.label}
					</div>
				</div>
			</div>
		);
	};

	return isLoading ? (
		<Loader />
	) : (
		<div className={styles.container}>
			<div className={styles.tabsContainer}>
				<TeamTab team={homeTeam} isActive={selectedTeam === homeTeam.id} />
				<TeamTab team={awayTeam} isActive={selectedTeam === awayTeam.id} />
			</div>
			<div className={styles.matchesList}>
				{selectedTeam === homeTeam.id
					? homeTeamMatches.map((match) => <MatchRow key={match.id} match={match} />)
					: awayTeamMatches.map((match) => <MatchRow key={match.id} match={match} />)}
			</div>
		</div>
	);
};

export default StatisticsModal;
